import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface AssessmentSteps {
  name: string;
  steps: {
    welcome_video: {
      active: boolean;
      thumbnail: string;
      file_type: string;
    };
    registration: {
      active: boolean;
      has_student_id_requirement: boolean;
      has_cas_id_requirement: boolean;
    };
    supplemental_materials: {
      active: boolean;
    };
    device_setup: {
      active: boolean;
    };
    practice: {
      active: boolean;
      competencies: ICompetency[];
      duration: number;
      name: string;
    };
    payment: {
      active: boolean;
    };
    assessment: {
      active: boolean;
      duration: number;
      competencies: ICompetency[];
    };
    closing_video: {
      active: boolean;
      thumbnail: string;
      file_type: string;
    };
  };
}

export enum CompetencyType {
  PASSIVE = 'passive',
  VIDEO = 'video',
  WRITTEN = 'written',
  QUESTIONS = 'questions',
  VERBAL_COMMUNICATION = 'verbal-communication',
  WRITTEN_COMMUNICATION = 'written-communication',
}

export interface ICompetency {
  name: string;
  uid: string;
  questions: number;
  rubric_scale: number;
  type: CompetencyType;
}

const useGetAssessmentSteps = (interviewUid: string) => {
  const body = {
    interview: interviewUid,
  };

  const { data, isLoading, isError } = useQuery<AssessmentSteps, Error>(
    ['getAssessmentStepDetails', interviewUid],
    async () =>
      fetchWithCsrfToken<AssessmentSteps>(
        `${PrependUrl.ASYNC}/steps/get_details`,
        'POST',
        body
      ),
    {
      enabled: !!interviewUid,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGetAssessmentSteps;
